export const restCountries = [
  {
    name: 'Afghanistan',
    nameAr: 'أفغانستان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/af.svg',
    code: '+93',
    iso: 'AF',
    currency: 'AFN',
  },
  {
    name: 'Albania',
    nameAr: 'ألبانيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/al.svg',
    code: '+355',
    iso: 'AL',
    currency: 'ALL',
  },
  {
    name: 'Algeria',
    nameAr: 'الجزائر',
    icon: 'https://hatscripts.github.io/circle-flags/flags/dz.svg',
    code: '+213',
    iso: 'DZ',
    currency: 'DZD',
  },
  {
    name: 'American Samoa',
    nameAr: 'ساموا الأمريكية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/as.svg',
    code: '+1684',
    iso: 'AS',
    currency: 'USD',
  },
  {
    name: 'Andorra',
    nameAr: 'أندورا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ad.svg',
    code: '+376',
    iso: 'AD',
    currency: 'EUR',
  },
  {
    name: 'Angola',
    nameAr: 'أنغولا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ao.svg',
    code: '+244',
    iso: 'AO',
    currency: 'AOA',
  },
  {
    name: 'Anguilla',
    nameAr: 'أنغيلا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ai.svg',
    code: '+1264',
    iso: 'AI',
    currency: 'XCD',
  },
  {
    name: 'Antarctica',
    nameAr: 'أنتاركتيكا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/aq.svg',
    code: '',
    iso: 'AQ',
    currency: '',
  },
  {
    name: 'Antigua and Barbuda',
    nameAr: 'أنتيغوا وباربودا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ag.svg',
    code: '+1268',
    iso: 'AG',
    currency: 'XCD',
  },
  {
    name: 'Argentina',
    nameAr: 'الأرجنتين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ar.svg',
    code: '+54',
    iso: 'AR',
    currency: 'ARS',
  },
  {
    name: 'Armenia',
    nameAr: 'أرمينيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/am.svg',
    code: '+374',
    iso: 'AM',
    currency: 'AMD',
  },
  {
    name: 'Aruba',
    nameAr: 'أروبا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/aw.svg',
    code: '+297',
    iso: 'AW',
    currency: 'AWG',
  },
  {
    name: 'Australia',
    nameAr: 'أستراليا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/au.svg',
    code: '+61',
    iso: 'AU',
    currency: 'AUD',
  },
  {
    name: 'Austria',
    nameAr: 'النمسا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/at.svg',
    code: '+43',
    iso: 'AT',
    currency: 'EUR',
  },
  {
    name: 'Azerbaijan',
    nameAr: 'أذربيجان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/az.svg',
    code: '+994',
    iso: 'AZ',
    currency: 'AZN',
  },
  {
    name: 'Bahamas',
    nameAr: 'جزر البهاما',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bs.svg',
    code: '+1242',
    iso: 'BS',
    currency: 'BSD',
  },
  {
    name: 'Bahrain',
    nameAr: 'البحرين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bh.svg',
    code: '+973',
    iso: 'BH',
    currency: 'BHD',
  },
  {
    name: 'Bangladesh',
    nameAr: 'بنغلاديش',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bd.svg',
    code: '+880',
    iso: 'BD',
    currency: 'BDT',
  },
  {
    name: 'Barbados',
    nameAr: 'بربادوس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bb.svg',
    code: '+1246',
    iso: 'BB',
    currency: 'BBD',
  },
  {
    name: 'Belarus',
    nameAr: 'بيلاروس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/by.svg',
    code: '+375',
    iso: 'BY',
    currency: 'BYN',
  },
  {
    name: 'Belgium',
    nameAr: 'بلجيكا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/be.svg',
    code: '+32',
    iso: 'BE',
    currency: 'EUR',
  },
  {
    name: 'Belize',
    nameAr: 'بليز',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bz.svg',
    code: '+501',
    iso: 'BZ',
    currency: 'BZD',
  },
  {
    name: 'Benin',
    nameAr: 'بنين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bj.svg',
    code: '+229',
    iso: 'BJ',
    currency: 'XOF',
  },
  {
    name: 'Bermuda',
    nameAr: 'برمودا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bm.svg',
    code: '+1441',
    iso: 'BM',
    currency: 'BMD',
  },
  {
    name: 'Bhutan',
    nameAr: 'بوتان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bt.svg',
    code: '+975',
    iso: 'BT',
    currency: 'BTN',
  },
  {
    name: 'Bolivia',
    nameAr: 'بوليفيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bo.svg',
    code: '+591',
    iso: 'BO',
    currency: 'BOB',
  },
  {
    name: 'Bosnia and Herzegovina',
    nameAr: 'البوسنة والهرسك',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ba.svg',
    code: '+387',
    iso: 'BA',
    currency: 'BAM',
  },
  {
    name: 'Botswana',
    nameAr: 'بوتسوانا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bw.svg',
    code: '+267',
    iso: 'BW',
    currency: 'BWP',
  },
  {
    name: 'Bouvet Island',
    nameAr: 'جزيرة بوفيت',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bv.svg',
    code: '+47',
    iso: 'BV',
    currency: '',
  },
  {
    name: 'Brazil',
    nameAr: 'البرازيل',
    icon: 'https://hatscripts.github.io/circle-flags/flags/br.svg',
    code: '+55',
    iso: 'BR',
    currency: 'BRL',
  },
  {
    name: 'British Indian Ocean Territory',
    nameAr: 'إقليم المحيط الهندي البريطاني',
    icon: 'https://hatscripts.github.io/circle-flags/flags/io.svg',
    code: '+246',
    iso: 'IO',
    currency: 'USD',
  },
  {
    name: 'British Virgin Islands',
    nameAr: 'جزر العذراء البريطانية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/vg.svg',
    code: '+1284',
    iso: 'VG',
    currency: 'USD',
  },
  {
    name: 'Brunei',
    nameAr: 'بروناي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bn.svg',
    code: '+673',
    iso: 'BN',
    currency: 'BND',
  },
  {
    name: 'Bulgaria',
    nameAr: 'بلغاريا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bg.svg',
    code: '+359',
    iso: 'BG',
    currency: 'BGN',
  },
  {
    name: 'Burkina Faso',
    nameAr: 'بوركينا فاسو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bf.svg',
    code: '+226',
    iso: 'BF',
    currency: 'XOF',
  },
  {
    name: 'Burundi',
    nameAr: 'بوروندي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bi.svg',
    code: '+257',
    iso: 'BI',
    currency: 'BIF',
  },
  {
    name: 'Cambodia',
    nameAr: 'كمبوديا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/kh.svg',
    code: '+855',
    iso: 'KH',
    currency: 'KHR',
  },
  {
    name: 'Cameroon',
    nameAr: 'الكاميرون',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cm.svg',
    code: '+237',
    iso: 'CM',
    currency: 'XAF',
  },
  {
    name: 'Canada',
    nameAr: 'كندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ca.svg',
    code: '+1',
    iso: 'CA',
    currency: 'CAD',
  },
  {
    name: 'Cape Verde',
    nameAr: 'الرأس الأخضر',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cv.svg',
    code: '+238',
    iso: 'CV',
    currency: 'CVE',
  },
  {
    name: 'Caribbean Netherlands',
    nameAr: 'هولندا الكاريبية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bq.svg',
    code: '+599',
    iso: 'BES islands',
    currency: 'USD',
  },
  {
    name: 'Cayman Islands',
    nameAr: 'جزر كايمان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ky.svg',
    code: '+1345',
    iso: 'KY',
    currency: 'KYD',
  },
  {
    name: 'Central African Republic',
    nameAr: 'جمهورية أفريقيا الوسطى',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cf.svg',
    code: '+236',
    iso: 'CF',
    currency: 'XAF',
  },
  {
    name: 'Chad',
    nameAr: 'تشاد',
    icon: 'https://hatscripts.github.io/circle-flags/flags/td.svg',
    code: '+235',
    iso: 'TD',
    currency: 'XAF',
  },
  {
    name: 'Chile',
    nameAr: 'تشيلي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cl.svg',
    code: '+56',
    iso: 'CL',
    currency: 'CLP',
  },
  {
    name: 'China',
    nameAr: 'الصين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cn.svg',
    code: '+86',
    iso: 'CN',
    currency: 'CNY',
  },
  {
    name: 'Christmas Island',
    nameAr: 'جزيرة الكريسماس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cx.svg',
    code: '+61',
    iso: 'CX',
    currency: 'AUD',
  },
  {
    name: 'Cocos (Keeling) Islands',
    nameAr: 'جزر كوكوس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cc.svg',
    code: '+61',
    iso: 'CC',
    currency: 'AUD',
  },
  {
    name: 'Colombia',
    nameAr: 'كولومبيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/co.svg',
    code: '+57',
    iso: 'CO',
    currency: 'COP',
  },
  {
    name: 'Comoros',
    nameAr: 'جزر القمر',
    icon: 'https://hatscripts.github.io/circle-flags/flags/km.svg',
    code: '+269',
    iso: 'KM',
    currency: 'KMF',
  },
  {
    name: 'Cook Islands',
    nameAr: 'جزر كوك',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ck.svg',
    code: '+682',
    iso: 'CK',
    currency: 'CKD',
  },
  {
    name: 'Costa Rica',
    nameAr: 'كوستاريكا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cr.svg',
    code: '+506',
    iso: 'CR',
    currency: 'CRC',
  },
  {
    name: 'Croatia',
    nameAr: 'كرواتيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/hr.svg',
    code: '+385',
    iso: 'HR',
    currency: 'EUR',
  },
  {
    name: 'Cuba',
    nameAr: 'كوبا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cu.svg',
    code: '+53',
    iso: 'CU',
    currency: 'CUC',
  },
  {
    name: 'Curaçao',
    nameAr: 'كوراساو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cw.svg',
    code: '+599',
    iso: 'CW',
    currency: 'ANG',
  },
  {
    name: 'Cyprus',
    nameAr: 'قبرص',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cy.svg',
    code: '+357',
    iso: 'CY',
    currency: 'EUR',
  },
  {
    name: 'Czechia',
    nameAr: 'التشيك',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cz.svg',
    code: '+420',
    iso: 'CZ',
    currency: 'CZK',
  },
  {
    name: 'DR Congo',
    nameAr: 'جمهورية الكونغو الديمقراطية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cd.svg',
    code: '+243',
    iso: 'CD',
    currency: 'CDF',
  },
  {
    name: 'Denmark',
    nameAr: 'الدنمارك',
    icon: 'https://hatscripts.github.io/circle-flags/flags/dk.svg',
    code: '+45',
    iso: 'DK',
    currency: 'DKK',
  },
  {
    name: 'Djibouti',
    nameAr: 'جيبوتي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/dj.svg',
    code: '+253',
    iso: 'DJ',
    currency: 'DJF',
  },
  {
    name: 'Dominica',
    nameAr: 'دومينيكا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/dm.svg',
    code: '+1767',
    iso: 'DM',
    currency: 'XCD',
  },
  {
    name: 'Dominican Republic',
    nameAr: 'جمهورية الدومينيكان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/do.svg',
    code: '+1',
    iso: 'DO',
    currency: 'DOP',
  },
  {
    name: 'Ecuador',
    nameAr: 'الإكوادور',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ec.svg',
    code: '+593',
    iso: 'EC',
    currency: 'USD',
  },
  {
    name: 'Egypt',
    nameAr: 'مصر',
    icon: 'https://hatscripts.github.io/circle-flags/flags/eg.svg',
    code: '+20',
    iso: 'EG',
    currency: 'EGP',
  },
  {
    name: 'European Union',
    icon: 'https://hatscripts.github.io/circle-flags/flags/eu.svg',
    code: '+33',
    iso: 'EU',
    currency: 'EUR',
  },
  {
    name: 'El Salvador',
    nameAr: 'السلفادور',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sv.svg',
    code: '+503',
    iso: 'SV',
    currency: 'USD',
  },
  {
    name: 'Equatorial Guinea',
    nameAr: 'غينيا الاستوائية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gq.svg',
    code: '+240',
    iso: 'GQ',
    currency: 'XAF',
  },
  {
    name: 'Eritrea',
    nameAr: 'إريتريا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/er.svg',
    code: '+291',
    iso: 'ER',
    currency: 'ERN',
  },
  {
    name: 'Estonia',
    nameAr: 'إستونيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ee.svg',
    code: '+372',
    iso: 'EE',
    currency: 'EUR',
  },
  {
    name: 'Eswatini',
    nameAr: 'إسواتيني',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sz.svg',
    code: '+268',
    iso: 'SZ',
    currency: 'SZL',
  },
  {
    name: 'Ethiopia',
    nameAr: 'إثيوبيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/et.svg',
    code: '+251',
    iso: 'ET',
    currency: 'ETB',
  },
  {
    name: 'Falkland Islands',
    nameAr: 'جزر فوكلاند',
    icon: 'https://hatscripts.github.io/circle-flags/flags/fk.svg',
    code: '+500',
    iso: 'FK',
    currency: 'FKP',
  },
  {
    name: 'Faroe Islands',
    nameAr: 'جزر فارو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/fo.svg',
    code: '+298',
    iso: 'FO',
    currency: 'DKK',
  },
  {
    name: 'Fiji',
    nameAr: 'فيجي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/fj.svg',
    code: '+679',
    iso: 'FJ',
    currency: 'FJD',
  },
  {
    name: 'Finland',
    nameAr: 'فنلندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/fi.svg',
    code: '+358',
    iso: 'FI',
    currency: 'EUR',
  },
  {
    name: 'France',
    nameAr: 'فرنسا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/fr.svg',
    code: '+33',
    iso: 'FR',
    currency: 'EUR',
  },
  {
    name: 'French Guiana',
    nameAr: 'غويانا الفرنسية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gf.svg',
    code: '+594',
    iso: 'GF',
    currency: 'EUR',
  },
  {
    name: 'French Polynesia',
    nameAr: 'بولينيزيا الفرنسية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pf.svg',
    code: '+689',
    iso: 'PF',
    currency: 'XPF',
  },
  {
    name: 'French Southern and Antarctic Lands',
    nameAr: 'الأراضي الفرنسية الجنوبية والقطبية الجنوبية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tf.svg',
    code: '+262',
    iso: 'TF',
    currency: 'EUR',
  },
  {
    name: 'Gabon',
    nameAr: 'الغابون',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ga.svg',
    code: '+241',
    iso: 'GA',
    currency: 'XAF',
  },
  {
    name: 'Gambia',
    nameAr: 'غامبيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gm.svg',
    code: '+220',
    iso: 'GM',
    currency: 'GMD',
  },
  {
    name: 'Georgia',
    nameAr: 'جورجيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ge.svg',
    code: '+995',
    iso: 'GE',
    currency: 'GEL',
  },
  {
    name: 'Germany',
    nameAr: 'ألمانيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/de.svg',
    code: '+49',
    iso: 'DE',
    currency: 'EUR',
  },
  {
    name: 'Ghana',
    nameAr: 'غانا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gh.svg',
    code: '+233',
    iso: 'GH',
    currency: 'GHS',
  },
  {
    name: 'Gibraltar',
    nameAr: 'جبل طارق',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gi.svg',
    code: '+350',
    iso: 'GI',
    currency: 'GIP',
  },
  {
    name: 'Greece',
    nameAr: 'اليونان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gr.svg',
    code: '+30',
    iso: 'GR',
    currency: 'EUR',
  },
  {
    name: 'Greenland',
    nameAr: 'غرينلاند',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gl.svg',
    code: '+299',
    iso: 'GL',
    currency: 'DKK',
  },
  {
    name: 'Grenada',
    nameAr: 'غرينادا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gd.svg',
    code: '+1473',
    iso: 'GD',
    currency: 'XCD',
  },
  {
    name: 'Guadeloupe',
    nameAr: 'غوادلوب',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gp.svg',
    code: '+590',
    iso: 'GP',
    currency: 'EUR',
  },
  {
    name: 'Guam',
    nameAr: 'غوام',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gu.svg',
    code: '+1671',
    iso: 'GU',
    currency: 'USD',
  },
  {
    name: 'Guatemala',
    nameAr: 'غواتيمالا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gt.svg',
    code: '+502',
    iso: 'GT',
    currency: 'GTQ',
  },
  {
    name: 'Guernsey',
    nameAr: 'غيرنزي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gg.svg',
    code: '+44',
    iso: 'GG',
    currency: 'GBP',
  },
  {
    name: 'Guinea',
    nameAr: 'غينيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gn.svg',
    code: '+224',
    iso: 'GN',
    currency: 'GNF',
  },
  {
    name: 'Guinea-Bissau',
    nameAr: 'غينيا بيساو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gw.svg',
    code: '+245',
    iso: 'GW',
    currency: 'XOF',
  },
  {
    name: 'Guyana',
    nameAr: 'غيانا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gy.svg',
    code: '+592',
    iso: 'GY',
    currency: 'GYD',
  },
  {
    name: 'Haiti',
    nameAr: 'هايتي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ht.svg',
    code: '+509',
    iso: 'HT',
    currency: 'HTG',
  },
  {
    name: 'Heard Island and McDonald Islands',
    nameAr: 'جزيرة هيرد وجزر ماكدونالد',
    icon: 'https://hatscripts.github.io/circle-flags/flags/hm.svg',
    code: '',
    iso: 'HM',
    currency: '',
  },
  {
    name: 'Honduras',
    nameAr: 'هندوراس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/hn.svg',
    code: '+504',
    iso: 'HN',
    currency: 'HNL',
  },
  {
    name: 'Hong Kong',
    nameAr: 'هونغ كونغ',
    icon: 'https://hatscripts.github.io/circle-flags/flags/hk.svg',
    code: '+852',
    iso: 'HK',
    currency: 'HKD',
  },
  {
    name: 'Hungary',
    nameAr: 'المجر',
    icon: 'https://hatscripts.github.io/circle-flags/flags/hu.svg',
    code: '+36',
    iso: 'HU',
    currency: 'HUF',
  },
  {
    name: 'Iceland',
    nameAr: 'أيسلندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/is.svg',
    code: '+354',
    iso: 'IS',
    currency: 'ISK',
  },
  {
    name: 'India',
    nameAr: 'الهند',
    icon: 'https://hatscripts.github.io/circle-flags/flags/in.svg',
    code: '+91',
    iso: 'IN',
    currency: 'INR',
  },
  {
    name: 'Indonesia',
    nameAr: 'إندونيسيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/id.svg',
    code: '+62',
    iso: 'ID',
    currency: 'IDR',
  },
  {
    name: 'Iran',
    nameAr: 'إيران',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ir.svg',
    code: '+98',
    iso: 'IR',
    currency: 'IRR',
  },
  {
    name: 'Iraq',
    nameAr: 'العراق',
    icon: 'https://hatscripts.github.io/circle-flags/flags/iq.svg',
    code: '+964',
    iso: 'IQ',
    currency: 'IQD',
  },
  {
    name: 'Ireland',
    nameAr: 'أيرلندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ie.svg',
    code: '+353',
    iso: 'IE',
    currency: 'EUR',
  },
  {
    name: 'Isle of Man',
    nameAr: 'جزيرة مان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/im.svg',
    code: '+44',
    iso: 'IM',
    currency: 'GBP',
  },
  {
    name: 'Israel',
    nameAr: 'إسرائيل',
    icon: 'https://hatscripts.github.io/circle-flags/flags/il.svg',
    code: '+972',
    iso: 'IL',
    currency: 'ILS',
  },
  {
    name: 'Italy',
    nameAr: 'إيطاليا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/it.svg',
    code: '+39',
    iso: 'IT',
    currency: 'EUR',
  },
  {
    name: 'Ivory Coast',
    nameAr: 'ساحل العاج',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ci.svg',
    code: '+225',
    iso: 'CI',
    currency: 'XOF',
  },
  {
    name: 'Jamaica',
    nameAr: 'جامايكا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/jm.svg',
    code: '+1876',
    iso: 'JM',
    currency: 'JMD',
  },
  {
    name: 'Japan',
    nameAr: 'اليابان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/jp.svg',
    code: '+81',
    iso: 'JP',
    currency: 'JPY',
  },
  {
    name: 'Jersey',
    nameAr: 'جيرزي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/je.svg',
    code: '+44',
    iso: 'JE',
    currency: 'GBP',
  },
  {
    name: 'Jordan',
    nameAr: 'الأردن',
    icon: 'https://hatscripts.github.io/circle-flags/flags/jo.svg',
    code: '+962',
    iso: 'JO',
    currency: 'JOD',
  },
  {
    name: 'Kazakhstan',
    nameAr: 'كازاخستان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/kz.svg',
    code: '+7',
    iso: 'KZ',
    currency: 'KZT',
  },
  {
    name: 'Kenya',
    nameAr: 'كينيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ke.svg',
    code: '+254',
    iso: 'KE',
    currency: 'KES',
  },
  {
    name: 'Kiribati',
    nameAr: 'كيريباتي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ki.svg',
    code: '+686',
    iso: 'KI',
    currency: 'AUD',
  },
  {
    name: 'Kosovo',
    nameAr: 'كوسوفو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/xk.svg',
    code: '+383',
    iso: 'XK',
    currency: 'EUR',
  },
  {
    name: 'Kuwait',
    nameAr: 'الكويت',
    icon: 'https://hatscripts.github.io/circle-flags/flags/kw.svg',
    code: '+965',
    iso: 'KW',
    currency: 'KWD',
  },
  {
    name: 'Kyrgyzstan',
    nameAr: 'قيرغيزستان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/kg.svg',
    code: '+996',
    iso: 'KG',
    currency: 'KGS',
  },
  {
    name: 'Laos',
    nameAr: 'لاوس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/la.svg',
    code: '+856',
    iso: 'LA',
    currency: 'LAK',
  },
  {
    name: 'Latvia',
    nameAr: 'لاتفيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/lv.svg',
    code: '+371',
    iso: 'LV',
    currency: 'EUR',
  },
  {
    name: 'Lebanon',
    nameAr: 'لبنان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/lb.svg',
    code: '+961',
    iso: 'LB',
    currency: 'LBP',
  },
  {
    name: 'Lesotho',
    nameAr: 'ليسوتو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ls.svg',
    code: '+266',
    iso: 'LS',
    currency: 'LSL',
  },
  {
    name: 'Liberia',
    nameAr: 'ليبيريا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/lr.svg',
    code: '+231',
    iso: 'LR',
    currency: 'LRD',
  },
  {
    name: 'Libya',
    nameAr: 'ليبيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ly.svg',
    code: '+218',
    iso: 'LY',
    currency: 'LYD',
  },
  {
    name: 'Liechtenstein',
    nameAr: 'ليختنشتاين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/li.svg',
    code: '+423',
    iso: 'LI',
    currency: 'CHF',
  },
  {
    name: 'Lithuania',
    nameAr: 'ليتوانيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/lt.svg',
    code: '+370',
    iso: 'LT',
    currency: 'EUR',
  },
  {
    name: 'Luxembourg',
    nameAr: 'لوكسمبورغ',
    icon: 'https://hatscripts.github.io/circle-flags/flags/lu.svg',
    code: '+352',
    iso: 'LU',
    currency: 'EUR',
  },
  {
    name: 'Macau',
    nameAr: 'ماكاو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mo.svg',
    code: '+853',
    iso: 'MO',
    currency: 'MOP',
  },
  {
    name: 'Madagascar',
    nameAr: 'مدغشقر',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mg.svg',
    code: '+261',
    iso: 'MG',
    currency: 'MGA',
  },
  {
    name: 'Malawi',
    nameAr: 'ملاوي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mw.svg',
    code: '+265',
    iso: 'MW',
    currency: 'MWK',
  },
  {
    name: 'Malaysia',
    nameAr: 'ماليزيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/my.svg',
    code: '+60',
    iso: 'MY',
    currency: 'MYR',
  },
  {
    name: 'Maldives',
    nameAr: 'جزر المالديف',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mv.svg',
    code: '+960',
    iso: 'MV',
    currency: 'MVR',
  },
  {
    name: 'Mali',
    nameAr: 'مالي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ml.svg',
    code: '+223',
    iso: 'ML',
    currency: 'XOF',
  },
  {
    name: 'Malta',
    nameAr: 'مالطا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mt.svg',
    code: '+356',
    iso: 'MT',
    currency: 'EUR',
  },
  {
    name: 'Marshall Islands',
    nameAr: 'جزر مارشال',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mh.svg',
    code: '+692',
    iso: 'MH',
    currency: 'USD',
  },
  {
    name: 'Martinique',
    nameAr: 'مارتينيك',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mq.svg',
    code: '+596',
    iso: 'MQ',
    currency: 'EUR',
  },
  {
    name: 'Mauritania',
    nameAr: 'موريتانيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mr.svg',
    code: '+222',
    iso: 'MR',
    currency: 'MRU',
  },
  {
    name: 'Mauritius',
    nameAr: 'موريشيوس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mu.svg',
    code: '+230',
    iso: 'MU',
    currency: 'MUR',
  },
  {
    name: 'Mayotte',
    nameAr: 'مايوت',
    icon: 'https://hatscripts.github.io/circle-flags/flags/yt.svg',
    code: '+262',
    iso: 'YT',
    currency: 'EUR',
  },
  {
    name: 'Mexico',
    nameAr: 'المكسيك',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mx.svg',
    code: '+52',
    iso: 'MX',
    currency: 'MXN',
  },
  {
    name: 'Micronesia',
    nameAr: 'ميكرونيزيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/fm.svg',
    code: '+691',
    iso: 'FM',
    currency: 'USD',
  },
  {
    name: 'Moldova',
    nameAr: 'مولدوفا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/md.svg',
    code: '+373',
    iso: 'MD',
    currency: 'MDL',
  },
  {
    name: 'Monaco',
    nameAr: 'موناكو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mc.svg',
    code: '+377',
    iso: 'MC',
    currency: 'EUR',
  },
  {
    name: 'Mongolia',
    nameAr: 'منغوليا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mn.svg',
    code: '+976',
    iso: 'MN',
    currency: 'MNT',
  },
  {
    name: 'Montenegro',
    nameAr: 'الجبل الأسود',
    icon: 'https://hatscripts.github.io/circle-flags/flags/me.svg',
    code: '+382',
    iso: 'ME',
    currency: 'EUR',
  },
  {
    name: 'Montserrat',
    nameAr: 'مونتسيرات',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ms.svg',
    code: '+1664',
    iso: 'MS',
    currency: 'XCD',
  },
  {
    name: 'Morocco',
    nameAr: 'المغرب',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ma.svg',
    code: '+212',
    iso: 'MA',
    currency: 'MAD',
  },
  {
    name: 'Mozambique',
    nameAr: 'موزمبيق',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mz.svg',
    code: '+258',
    iso: 'MZ',
    currency: 'MZN',
  },
  {
    name: 'Myanmar',
    nameAr: 'ميانمار',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mm.svg',
    code: '+95',
    iso: 'MM',
    currency: 'MMK',
  },
  {
    name: 'Namibia',
    nameAr: 'ناميبيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/na.svg',
    code: '+264',
    iso: 'NA',
    currency: 'NAD',
  },
  {
    name: 'Nauru',
    nameAr: 'ناورو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/nr.svg',
    code: '+674',
    iso: 'NR',
    currency: 'AUD',
  },
  {
    name: 'Nepal',
    nameAr: 'نيبال',
    icon: 'https://hatscripts.github.io/circle-flags/flags/np.svg',
    code: '+977',
    iso: 'NP',
    currency: 'NPR',
  },
  {
    name: 'Netherlands',
    nameAr: 'هولندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/nl.svg',
    code: '+31',
    iso: 'NL',
    currency: 'EUR',
  },
  {
    name: 'New Caledonia',
    nameAr: 'كاليدونيا الجديدة',
    icon: 'https://hatscripts.github.io/circle-flags/flags/nc.svg',
    code: '+687',
    iso: 'NC',
    currency: 'XPF',
  },
  {
    name: 'New Zealand',
    nameAr: 'نيوزيلندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/nz.svg',
    code: '+64',
    iso: 'NZ',
    currency: 'NZD',
  },
  {
    name: 'Nicaragua',
    nameAr: 'نيكاراغوا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ni.svg',
    code: '+505',
    iso: 'NI',
    currency: 'NIO',
  },
  {
    name: 'Niger',
    nameAr: 'النيجر',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ne.svg',
    code: '+227',
    iso: 'NE',
    currency: 'XOF',
  },
  {
    name: 'Nigeria',
    nameAr: 'نيجيريا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ng.svg',
    code: '+234',
    iso: 'NG',
    currency: 'NGN',
  },
  {
    name: 'Niue',
    nameAr: 'نيوي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/nu.svg',
    code: '+683',
    iso: 'NU',
    currency: 'NZD',
  },
  {
    name: 'Norfolk Island',
    nameAr: 'جزيرة نورفولك',
    icon: 'https://hatscripts.github.io/circle-flags/flags/nf.svg',
    code: '+672',
    iso: 'NF',
    currency: 'AUD',
  },
  {
    name: 'North Korea',
    nameAr: 'كوريا الشمالية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/kp.svg',
    code: '+850',
    iso: 'KP',
    currency: 'KPW',
  },
  {
    name: 'North Macedonia',
    nameAr: 'مقدونيا الشمالية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mk.svg',
    code: '+389',
    iso: 'MK',
    currency: 'MKD',
  },
  {
    name: 'Northern Mariana Islands',
    nameAr: 'جزر ماريانا الشمالية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mp.svg',
    code: '+1670',
    iso: 'MP',
    currency: 'USD',
  },
  {
    name: 'Norway',
    nameAr: 'النرويج',
    icon: 'https://hatscripts.github.io/circle-flags/flags/no.svg',
    code: '+47',
    iso: 'NO',
    currency: 'NOK',
  },
  {
    name: 'Oman',
    nameAr: 'عُمان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/om.svg',
    code: '+968',
    iso: 'OM',
    currency: 'OMR',
  },
  {
    name: 'Pakistan',
    nameAr: 'باكستان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pk.svg',
    code: '+92',
    iso: 'PK',
    currency: 'PKR',
  },
  {
    name: 'Palau',
    nameAr: 'بالاو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pw.svg',
    code: '+680',
    iso: 'PW',
    currency: 'USD',
  },
  {
    name: 'Palestine',
    nameAr: 'فلسطين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ps.svg',
    code: '+970',
    iso: 'PS',
    currency: 'JOD',
  },
  {
    name: 'Panama',
    nameAr: 'بنما',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pa.svg',
    code: '+507',
    iso: 'PA',
    currency: 'PAB',
  },
  {
    name: 'Papua New Guinea',
    nameAr: 'بابوا غينيا الجديدة',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pg.svg',
    code: '+675',
    iso: 'PG',
    currency: 'PGK',
  },
  {
    name: 'Paraguay',
    nameAr: 'باراغواي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/py.svg',
    code: '+595',
    iso: 'PY',
    currency: 'PYG',
  },
  {
    name: 'Peru',
    nameAr: 'بيرو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pe.svg',
    code: '+51',
    iso: 'PE',
    currency: 'PEN',
  },
  {
    name: 'Philippines',
    nameAr: 'الفلبين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ph.svg',
    code: '+63',
    iso: 'PH',
    currency: 'PHP',
  },
  {
    name: 'Pitcairn Islands',
    nameAr: 'جزر بيتكيرن',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pn.svg',
    code: '+64',
    iso: 'PN',
    currency: 'NZD',
  },
  {
    name: 'Poland',
    nameAr: 'بولندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pl.svg',
    code: '+48',
    iso: 'PL',
    currency: 'PLN',
  },
  {
    name: 'Portugal',
    nameAr: 'البرتغال',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pt.svg',
    code: '+351',
    iso: 'PT',
    currency: 'EUR',
  },
  {
    name: 'Puerto Rico',
    nameAr: 'بورتوريكو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pr.svg',
    code: '+1',
    iso: 'PR',
    currency: 'USD',
  },
  {
    name: 'Qatar',
    nameAr: 'قطر',
    icon: 'https://hatscripts.github.io/circle-flags/flags/qa.svg',
    code: '+974',
    iso: 'QA',
    currency: 'QAR',
  },
  {
    name: 'Republic of the Congo',
    nameAr: 'جمهورية الكونغو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/cg.svg',
    code: '+242',
    iso: 'CG',
    currency: 'XAF',
  },
  {
    name: 'Romania',
    nameAr: 'رومانيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ro.svg',
    code: '+40',
    iso: 'RO',
    currency: 'RON',
  },
  {
    name: 'Russia',
    nameAr: 'روسيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ru.svg',
    code: '+7',
    iso: 'RU',
    currency: 'RUB',
  },
  {
    name: 'Rwanda',
    nameAr: 'رواندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/rw.svg',
    code: '+250',
    iso: 'RW',
    currency: 'RWF',
  },
  {
    name: 'Réunion',
    nameAr: 'ريونيون',
    icon: 'https://hatscripts.github.io/circle-flags/flags/re.svg',
    code: '+262',
    iso: 'RE',
    currency: 'EUR',
  },
  {
    name: 'Saint Barthélemy',
    nameAr: 'سان بارتليمي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/bl.svg',
    code: '+590',
    iso: 'BL',
    currency: 'EUR',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    nameAr: 'سانت هيلينا وأسينشن وتريستان دا كونها',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sh.svg',
    code: '+2',
    iso: 'Saint Helena',
    currency: 'GBP',
  },
  {
    name: 'Saint Kitts and Nevis',
    nameAr: 'سانت كيتس ونيفيس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/kn.svg',
    code: '+1869',
    iso: 'KN',
    currency: 'XCD',
  },
  {
    name: 'Saint Lucia',
    nameAr: 'سانت لوسيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/lc.svg',
    code: '+1758',
    iso: 'LC',
    currency: 'XCD',
  },
  {
    name: 'Saint Martin',
    nameAr: 'سان مارتن',
    icon: 'https://hatscripts.github.io/circle-flags/flags/mf.svg',
    code: '+590',
    iso: 'MF',
    currency: 'EUR',
  },
  {
    name: 'Saint Pierre and Miquelon',
    nameAr: 'سان بيير وميكلون',
    icon: 'https://hatscripts.github.io/circle-flags/flags/pm.svg',
    code: '+508',
    iso: 'PM',
    currency: 'EUR',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    nameAr: 'سانت فنسنت وجزر غرينادين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/vc.svg',
    code: '+1784',
    iso: 'VC',
    currency: 'XCD',
  },
  {
    name: 'Samoa',
    nameAr: 'ساموا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ws.svg',
    code: '+685',
    iso: 'WS',
    currency: 'WST',
  },
  {
    name: 'San Marino',
    nameAr: 'سان مارينو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sm.svg',
    code: '+378',
    iso: 'SM',
    currency: 'EUR',
  },
  {
    name: 'Saudi Arabia',
    nameAr: 'المملكة العربية السعودية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sa.svg',
    code: '+966',
    iso: 'SA',
    currency: 'SAR',
  },
  {
    name: 'Senegal',
    nameAr: 'السنغال',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sn.svg',
    code: '+221',
    iso: 'SN',
    currency: 'XOF',
  },
  {
    name: 'Serbia',
    nameAr: 'صربيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/rs.svg',
    code: '+381',
    iso: 'RS',
    currency: 'RSD',
  },
  {
    name: 'Seychelles',
    nameAr: 'سيشل',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sc.svg',
    code: '+248',
    iso: 'SC',
    currency: 'SCR',
  },
  {
    name: 'Sierra Leone',
    nameAr: 'سيراليون',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sl.svg',
    code: '+232',
    iso: 'SL',
    currency: 'SLL',
  },
  {
    name: 'Singapore',
    nameAr: 'سنغافورة',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sg.svg',
    code: '+65',
    iso: 'SG',
    currency: 'SGD',
  },
  {
    name: 'Sint Maarten',
    nameAr: 'سينت مارتن',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sx.svg',
    code: '+1721',
    iso: 'SX',
    currency: 'ANG',
  },
  {
    name: 'Slovakia',
    nameAr: 'سلوفاكيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sk.svg',
    code: '+421',
    iso: 'SK',
    currency: 'EUR',
  },
  {
    name: 'Slovenia',
    nameAr: 'سلوفينيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/si.svg',
    code: '+386',
    iso: 'SI',
    currency: 'EUR',
  },
  {
    name: 'Solomon Islands',
    nameAr: 'جزر سليمان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sb.svg',
    code: '+677',
    iso: 'SB',
    currency: 'SBD',
  },
  {
    name: 'Somalia',
    nameAr: 'الصومال',
    icon: 'https://hatscripts.github.io/circle-flags/flags/so.svg',
    code: '+252',
    iso: 'SO',
    currency: 'SOS',
  },
  {
    name: 'South Africa',
    nameAr: 'جنوب أفريقيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/za.svg',
    code: '+27',
    iso: 'ZA',
    currency: 'ZAR',
  },
  {
    name: 'South Georgia',
    nameAr: 'جورجيا الجنوبية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gs.svg',
    code: '+500',
    iso: 'GS',
    currency: 'SHP',
  },
  {
    name: 'South Korea',
    nameAr: 'كوريا الجنوبية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/kr.svg',
    code: '+82',
    iso: 'KR',
    currency: 'KRW',
  },
  {
    name: 'South Sudan',
    nameAr: 'جنوب السودان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ss.svg',
    code: '+211',
    iso: 'SS',
    currency: 'SSP',
  },
  {
    name: 'Spain',
    nameAr: 'إسبانيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/es.svg',
    code: '+34',
    iso: 'ES',
    currency: 'EUR',
  },
  {
    name: 'Sri Lanka',
    nameAr: 'سريلانكا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/lk.svg',
    code: '+94',
    iso: 'LK',
    currency: 'LKR',
  },
  {
    name: 'Sudan',
    nameAr: 'السودان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sd.svg',
    code: '+249',
    iso: 'SD',
    currency: 'SDG',
  },
  {
    name: 'Suriname',
    nameAr: 'سورينام',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sr.svg',
    code: '+597',
    iso: 'SR',
    currency: 'SRD',
  },
  {
    name: 'Svalbard and Jan Mayen',
    nameAr: 'سفالبارد وجان ماين',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sj.svg',
    code: '+4779',
    iso: 'SJ',
    currency: 'NOK',
  },
  {
    name: 'Sweden',
    nameAr: 'السويد',
    icon: 'https://hatscripts.github.io/circle-flags/flags/se.svg',
    code: '+46',
    iso: 'SE',
    currency: 'SEK',
  },
  {
    name: 'Switzerland',
    nameAr: 'سويسرا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ch.svg',
    code: '+41',
    iso: 'CH',
    currency: 'CHF',
  },
  {
    name: 'Syria',
    nameAr: 'سوريا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/sy.svg',
    code: '+963',
    iso: 'SY',
    currency: 'SYP',
  },
  {
    name: 'São Tomé and Príncipe',
    nameAr: 'ساو تومي وبرينسيبي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/st.svg',
    code: '+239',
    iso: 'ST',
    currency: 'STN',
  },
  {
    name: 'Taiwan',
    nameAr: 'تايوان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tw.svg',
    code: '+886',
    iso: 'TW',
    currency: 'TWD',
  },
  {
    name: 'Tajikistan',
    nameAr: 'طاجيكستان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tj.svg',
    code: '+992',
    iso: 'TJ',
    currency: 'TJS',
  },
  {
    name: 'Tanzania',
    nameAr: 'تنزانيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tz.svg',
    code: '+255',
    iso: 'TZ',
    currency: 'TZS',
  },
  {
    name: 'Thailand',
    nameAr: 'تايلاند',
    icon: 'https://hatscripts.github.io/circle-flags/flags/th.svg',
    code: '+66',
    iso: 'TH',
    currency: 'THB',
  },
  {
    name: 'Timor-Leste',
    nameAr: 'تيمور الشرقية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tl.svg',
    code: '+670',
    iso: 'TL',
    currency: 'USD',
  },
  {
    name: 'Togo',
    nameAr: 'توغو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tg.svg',
    code: '+228',
    iso: 'TG',
    currency: 'XOF',
  },
  {
    name: 'Tokelau',
    nameAr: 'توكيلاو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tk.svg',
    code: '+690',
    iso: 'TK',
    currency: 'NZD',
  },
  {
    name: 'Tonga',
    nameAr: 'تونغا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/to.svg',
    code: '+676',
    iso: 'TO',
    currency: 'TOP',
  },
  {
    name: 'Trinidad and Tobago',
    nameAr: 'ترينيداد وتوباغو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tt.svg',
    code: '+1868',
    iso: 'TT',
    currency: 'TTD',
  },
  {
    name: 'Tunisia',
    nameAr: 'تونس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tn.svg',
    code: '+216',
    iso: 'TN',
    currency: 'TND',
  },
  {
    name: 'Turkey',
    nameAr: 'تركيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tr.svg',
    code: '+90',
    iso: 'TR',
    currency: 'TRY',
  },
  {
    name: 'Turkmenistan',
    nameAr: 'تركمانستان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tm.svg',
    code: '+993',
    iso: 'TM',
    currency: 'TMT',
  },
  {
    name: 'Turks and Caicos Islands',
    nameAr: 'جزر توركس وكايكوس',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tc.svg',
    code: '+1649',
    iso: 'TC',
    currency: 'USD',
  },
  {
    name: 'Tuvalu',
    nameAr: 'توفالو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/tv.svg',
    code: '+688',
    iso: 'TV',
    currency: 'AUD',
  },
  {
    name: 'Uganda',
    nameAr: 'أوغندا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ug.svg',
    code: '+256',
    iso: 'UG',
    currency: 'UGX',
  },
  {
    name: 'Ukraine',
    nameAr: 'أوكرانيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ua.svg',
    code: '+380',
    iso: 'UA',
    currency: 'UAH',
  },
  {
    name: 'United Arab Emirates',
    nameAr: 'الإمارات العربية المتحدة',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ae.svg',
    code: '+971',
    iso: 'AE',
    currency: 'AED',
  },
  {
    name: 'United Kingdom',
    nameAr: 'المملكة المتحدة',
    icon: 'https://hatscripts.github.io/circle-flags/flags/gb.svg',
    code: '+44',
    iso: 'GB',
    currency: 'GBP',
  },
  {
    name: 'United States',
    nameAr: 'الولايات المتحدة الأمريكية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/us.svg',
    code: '+1',
    iso: 'US',
    currency: 'USD',
  },
  {
    name: 'United States Minor Outlying Islands',
    nameAr: 'جزر الولايات المتحدة النائية الصغرى',
    icon: 'https://hatscripts.github.io/circle-flags/flags/um.svg',
    code: '+268',
    iso: 'UM',
    currency: 'USD',
  },
  {
    name: 'United States Virgin Islands',
    nameAr: 'جزر العذراء الأمريكية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/vi.svg',
    code: '+1340',
    iso: 'VI',
    currency: 'USD',
  },
  {
    name: 'Uruguay',
    nameAr: 'أوروغواي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/uy.svg',
    code: '+598',
    iso: 'UY',
    currency: 'UYU',
  },
  {
    name: 'Uzbekistan',
    nameAr: 'أوزبكستان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/uz.svg',
    code: '+998',
    iso: 'UZ',
    currency: 'UZS',
  },
  {
    name: 'Vanuatu',
    nameAr: 'فانواتو',
    icon: 'https://hatscripts.github.io/circle-flags/flags/vu.svg',
    code: '+678',
    iso: 'VU',
    currency: 'VUV',
  },
  {
    name: 'Vatican City',
    nameAr: 'مدينة الفاتيكان',
    icon: 'https://hatscripts.github.io/circle-flags/flags/va.svg',
    code: '+3',
    iso: 'VA',
    currency: 'EUR',
  },
  {
    name: 'Venezuela',
    nameAr: 'فنزويلا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ve.svg',
    code: '+58',
    iso: 'VE',
    currency: 'VES',
  },
  {
    name: 'Vietnam',
    nameAr: 'فيتنام',
    icon: 'https://hatscripts.github.io/circle-flags/flags/vn.svg',
    code: '+84',
    iso: 'VN',
    currency: 'VND',
  },
  {
    name: 'Wallis and Futuna',
    nameAr: 'واليس وفوتونا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/wf.svg',
    code: '+681',
    iso: 'WF',
    currency: 'XPF',
  },
  {
    name: 'Western Sahara',
    nameAr: 'الصحراء الغربية',
    icon: 'https://hatscripts.github.io/circle-flags/flags/eh.svg',
    code: '+2',
    iso: 'EH',
    currency: 'DZD',
  },
  {
    name: 'Yemen',
    nameAr: 'اليمن',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ye.svg',
    code: '+967',
    iso: 'YE',
    currency: 'YER',
  },
  {
    name: 'Zambia',
    nameAr: 'زامبيا',
    icon: 'https://hatscripts.github.io/circle-flags/flags/zm.svg',
    code: '+260',
    iso: 'ZM',
    currency: 'ZMW',
  },
  {
    name: 'Zimbabwe',
    nameAr: 'زيمبابوي',
    icon: 'https://hatscripts.github.io/circle-flags/flags/zw.svg',
    code: '+263',
    iso: 'ZW',
    currency: 'ZWL',
  },
  {
    name: 'Åland Islands',
    nameAr: 'جزر أولاند',
    icon: 'https://hatscripts.github.io/circle-flags/flags/ax.svg',
    code: '+35818',
    iso: 'AX',
    currency: 'EUR',
  },
];
